module.exports = __webpack_public_path__ + "img/广东省人民医院.f76ad4a3.png";